import React, {memo, useEffect, useMemo, useState} from "react"
import {useOutsideDetector} from "../../hooks/outside-detector"
import {useDispatch, useSelector} from "react-redux"
import {setResetCountdown} from "../../store/control/actions"
import {useLocalization} from "../../hooks/localization"
import "./index.scss"

let timer
export const ResetButtonPopover = memo(function ResetButtonPopover() {
    const {t} = useLocalization()
    const dispatch = useDispatch()
    const [isCloseable, setIsCloseable] = useState(false)
    const resetButtonStatus = useSelector(state => state.control.somResetCountdown)
    const buttonStatus = resetButtonStatus.split("-")
    const buttonSecond = Number(buttonStatus[1])
    const outsideClick = useOutsideDetector(isCloseable, () => dispatch(setResetCountdown("")))

    const resetButtonLoader = useMemo(() => {
        const buttonSecond = Number(buttonStatus[1])
        if (buttonStatus[0] === "buttonpressed") {
            if (buttonSecond >= 0 && buttonSecond < 3) {
                return "step-one"
            } else if (buttonSecond >= 3 && buttonSecond < 10) {
                return "step-two"
            } else if (buttonSecond >= 10 && buttonSecond < 30) {
                return "step-three"
            } else if (buttonSecond >= 30) {
                return "step-four"
            } else {
                return ""
            }
        }
        return ""
    }, [buttonStatus])

    const resetButtonMessage = useMemo(() => {
        if (buttonStatus[0] === "buttonpressed") {
            if (buttonSecond >= 0 && buttonSecond < 3) {
                return t("ringing")
            } else if (buttonSecond >= 3 && buttonSecond < 10) {
                return t("hardware_resetting")
            } else if (buttonSecond >= 10 && buttonSecond < 30) {
                return t("software_resetting")
            } else if (buttonSecond >= 30) {
                return t("database_resetting")
            } else {
                return ""
            }
        }
        if (buttonStatus[0] === "som_reset_countdown") {
            return t("software_resetting")
        }
        return ""
    }, [t, buttonStatus, buttonSecond])

    useEffect(() => {
        if (
            buttonStatus[0] === "buttonreleased" ||
            buttonStatus[0] === "" ||
            (buttonStatus[0] === "som_reset_countdown" && Number(buttonStatus[1]) === 0)
        ) {
            timer = setTimeout(() => {
                setIsCloseable(true)
            }, 1000)
            return () => clearTimeout(timer)
        }
    }, [buttonStatus])

    return (
        <div className="reset-button-overlay">
            <div className="reset-button-popover-container" ref={outsideClick}>
                <div className="reset-button-action-container">
                    <div className="reset-button-actions">
                        <span
                            style={{
                                color:
                                    buttonStatus[0] === "buttonpressed" && buttonSecond >= 0 && buttonSecond < 3
                                        ? "rgb(0, 212, 0)"
                                        : "#fff"
                            }}
                        >
                            (0-3sn)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t("ring_the_bell")}
                        </span>
                        <span
                            style={{
                                color:
                                    buttonStatus[0] === "buttonpressed" && buttonSecond >= 3 && buttonSecond < 10
                                        ? "rgb(0, 212, 0)"
                                        : "#fff"
                            }}
                        >
                            (3-10sn)&nbsp;&nbsp;&nbsp;&nbsp;{t("hardware_reset")}
                        </span>
                        <span
                            style={{
                                color:
                                    buttonStatus[0] === "buttonpressed" && buttonSecond >= 10 && buttonSecond < 30
                                        ? "rgb(0, 212, 0)"
                                        : "#fff"
                            }}
                        >
                            (10-30sn)&nbsp;&nbsp;{t("software_reset")}
                        </span>
                        <span
                            style={{
                                color:
                                    buttonStatus[0] === "buttonpressed" && buttonSecond >= 30
                                        ? "rgb(0, 212, 0)"
                                        : "#fff"
                            }}
                        >
                            (30sn&gt;)&nbsp;&nbsp;&nbsp;&nbsp;{t("database_reset")}
                        </span>
                    </div>
                    <div className="reset-button-timer">{buttonStatus[1] || "0"}</div>
                </div>
                <span className="reset-button-output">{resetButtonMessage}</span>
                <div className="reset-button-loader-container">
                    <div className="reset-button-timeline">
                        <span>0</span>
                        <span>3</span>
                        <span>10</span>
                        <span>30</span>
                    </div>
                    <div className="reset-button-loader">
                        <span className={resetButtonLoader} />
                    </div>
                </div>
                <div className="reset-button-buttons">
                    <span onClick={() => dispatch(setResetCountdown(""))}>{t("close")}</span>
                </div>
            </div>
        </div>
    )
})
